define([
    "jquery",
    "underscore",
    "marionette",
    "views/common/chartjs_view",
    "views/common/chartjs_utils",
    "views/common/chartjs_options",
    "behaviors/datatables_behavior",
    "bootstrap.datepicker"
], function($, _, Marionette, ChartView, chartUtils, chartOptions, DatatablesBehavior){
    return Marionette.LayoutView.extend({
        el: '#content_layout',

        behaviors: {
            datatables: {
                behaviorClass: DatatablesBehavior
            }
        },

        ui:{
            'startDatepicker': '#datetimepicker_start',
            'endDatepicker': '#datetimepicker_end',
            'periodCommissionValue': '.period_commission_value',
            'filterBtn': '#filter_btn',
            'filters': '.filter',
            'inputDaily': '#input_daily',
            'inputMonthly': '#input_monthly'
        },

        regions: {
            'chart': '#chart'
        },

        events: {
            'click @ui.filterBtn': function(e){
                if(e) e.preventDefault();

                this.chartView.reload();
                this.updatePeriodCommission();
            },
            'click @ui.inputDaily': 'viewDaily',
            'click @ui.inputMonthly': 'viewMonthly'
        },


        viewDaily: function(e) {
            $('#daily_link').get(0).click();
        },

        viewMonthly: function(e) {
            $('#monthly_link').get(0).click();
        },

        updatePeriodCommission: function(){

            // we first need to get the actual status of filters
            // TODO - Change to behavior
            var data = {};
            this.ui.filters.each(function(index, item){
                data[$(this).attr("name")] = $(this).val();
            });

            // We get the datas from the server
            var that = this;
            $.ajax({
                url: "/rest_report/period_commission",
                method: "POST",
                data : data
            }).done(
                function( res ){
                    that.ui.periodCommissionValue.html( res );
                }
            ).fail(
                function(){
                    that.ui.periodCommissionValue.html("-");
                }
            );
        },

        initialize: function(){
            this.bindUIElements();

            var that = this;

            // Initialize our 2 datepickers
            this.ui.startDatepicker.datetimepicker({
                format: 'YYYY-MM-DD'
            });
            this.ui.endDatepicker.datetimepicker({
                format: 'YYYY-MM-DD'
            });

            this.chartView = new ChartView({
                ajax: {
                    url: "/rest_report/commission_traders_all_daily_chart",
                    method: "POST",
                    prepareData: function () {
                        var data = [];
                        that.ui.filters.each(function (index, item) {
                            data[$(this).attr("name")] = $(this).val();
                        });

                        return data;
                    },
                    parseChartData: function (data) {
                        return {
                            labels: data.legend,
                            datasets: [
                                {
                                    ...chartOptions.barChartDatasetOptions,
                                    label: "Commission",
                                    data: data.data.map((el) => +el),
                                },
                            ],
                        };
                    },
                },
                chartType: "bar",
                chartOptions: $.extend(true, {}, chartOptions.barChartOptions, {
                    scales: { y: { title: { text: "Commission" } } },
                    plugins: {
                        tooltip: {external: chartUtils.customTooltip({label: "Commission: ", dateLabel: "Account No.: "})}
                    }
                }),
                chartPlugins: [chartUtils.MirrorEffect],
                pagination: {
                    length: 30,
                },
            });
            this.showChildView('chart', this.chartView);

            this.updatePeriodCommission();
            this.triggerMethod('init:table', {
                url: '/rest_report/commission_traders_all_daily',
                order: [[ 4, "desc" ]],
                columns: [
                    {
                        'name':'child_account',
                        'data':'child_account'
                    },
                    {
                        'name':'name',
                        'data':'name'
                    },
                    {
                        'name':'equity',
                        'data':'equity'
                    },
                    {
                        'name':'volume',
                        'data':'volume'
                    },
                    {
                        'name':'commission',
                        'data':'commission'
                    }
                ]
            });

        }
    });
});
